export default __webpack_public_path__ + "static/tab-banner-f16233f08b183be1d4fad8b5638297c7.png";